import React from "react"
import { Panel, Radio, Col, Checkbox, Row, Button } from "react-bootstrap"
import AscModal from "../Elements/Modal/Modal";
import InlineForm from "../Elements/FromGroup/InlineForm"
import "../Elements/FromGroup/form_select.css";
import moment from 'moment';
import 'moment/locale/ja';
import { ViewVoiceTextElement, ViewAudioControlElement} from "../Elements/AscElements/CallAnalysisElements";
import SetButtonWithSpeechBubble from "../Elements/AscElements/SetButtonWithSpeechBubble";
import SetDataWithSpeechBubble from "../Elements/AscElements/SetDataWithSpeechBubble";
import { ViewCallResultElement } from "../Elements/AscElements/CallResultElements";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as solidfaIcon from "@fortawesome/free-solid-svg-icons";
import { MultiSelect } from "react-multi-select-component";
import Select from "react-select";
import CommonTable from "../Elements/Table/CommonTable";
import AscComponent from '../../components/AscComponent';
import CallHistoryDetailModal from "./CallHistoryDetailModal";
import * as GlobalConst from "../../components/AscConstants";

moment.locale('ja');

export default class CallHistoryModal extends AscComponent {
    constructor(props) {
        super(props);

        this.table = React.createRef();
        this.state = {
            columns: this.getColumnsData(),
            data: [],
            pages: null,
            loading: false,
            filtered: [],
            hidden_filtered: [],

            // modal item
            show: false,
            modalType: null,
            external_arr: [],
            display_number: [],
            search_target: 'deleted',
            applied_search_target: 'deleted'
        }

        this.exec_status_list = this.getSelectOption('exec_status_list', this.props.langText.SelectOption)
        this.delete_search_target_list = this.getSelectOption('delete_search_target_list', this.props.langText.SelectOption)
    }

    componentDidUpdate(prevProps) {
        const isDeleteHistoryModal = this.props.state.modalType === "callHistoryDeleteHistory";

        if ((isDeleteHistoryModal && prevProps.state.modalType !== "callHistoryDeleteHistory") 
            && this.getScopeLessThanEqual(GlobalConst.SCOPE_OBJECT.company)) {
            this.getAllExternal(this.props.userInfo.company_id);
        }

        // 「閉じる」「×」で閉じた時点で検索条件を初期化する
        // (閉じてもmodalTypeは変わらないため、showの変化で判定する)
        if (isDeleteHistoryModal && prevProps.state.show && !this.props.state.show) {
            this.initDeleteHistoryCondition();
        }
    }

    /**
     * 履歴削除状況モーダルの検索条件を初期化する
     */
    initDeleteHistoryCondition = () => {
        this.setState({
            filtered: [],
            hidden_filtered: [],
            display_number: [],
            external_arr: [],
            data: [],
            search_target: 'deleted',
            applied_search_target: 'deleted'
        }, () => {
            if (this.getScopeLessThanEqual(GlobalConst.SCOPE_OBJECT.company)) {
                this.getAllExternal(this.props.userInfo.company_id);
            }
        });
    }

    getColumnsData = () => {
        let {
            langText,
            boardWidth
        } = this.props;
        let columns = [];

        // ID
        columns.push({
            Header: langText.Body.Id,
            sortable: false,
            accessor: "id",
            width: boardWidth.id
        });

        // 会社名
        if (this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.oem)) {
            columns.push({
                Header: langText.Body.CompanyName,
                sortable: false,
                accessor: "cm12_companies.company_name",
                width: boardWidth.xlarge
            });
        }

        // 実行日時
        columns.push({
            Header: langText.Body.ExecTime,
            sortable: true,
            accessor: "execution_start_datetime",
            Cell: data => {
                return data.value ? this.getMomentTime({date: data.value, format: "YYYY/MM/DD HH:mm:ss"}) : "";
            }
        });

        // 実行ユーザー
        columns.push({
            Header: langText.Body.ExecUser,
            sortable: false,
            accessor: "cm15_users",
            width: boardWidth.smedium,
            Cell: data => {
                return data.value ? data.value.user_name_sei + data.value.user_name_mei : this.props.langText.Body.SaveDeadLineExceeding;
            }
        });

        // 実行状況
        columns.push({
            Header: langText.Body.ExecStatus,
            sortable: false,
            accessor: "status",
            width: boardWidth.smedium,
            Cell: data => {
                let label = "";
                let style = "call-history-delete-status ";
                
                switch (data.value) {
                    case "WAITING":
                        label = this.props.langText.Body.Waiting;
                        style += "waiting";
                        break;
                    case "CREATING":
                        label = this.props.langText.Body.Processing;
                        style += "creating";
                        break;
                    case "FAILED":
                        label = this.props.langText.Body.FileFailed;
                        style += "failed";
                        break;
                    case "CREATED":
                        label = this.props.langText.Body.Success;
                        style += "created";
                        break;
                    default:
                        break;
                }

                return (
                    <div className={style}>
                        {label}
                    </div>
                );
            }
        });

        // 削除件数
        columns.push({
            Header: langText.Body.DeleteCount,
            sortable: false,
            accessor: "del_count",
            width: boardWidth.smedium,
            Cell: data => {
                return `${data.value !== null ? data.value.toLocaleString() + langText.Body.Count : langText.Message.TooManyResultsMessage}`;
            }
        });

        // 操作
        columns.push({
            Header: langText.Body.Control,
            sortable: false,
            accessor: "id",
            width: boardWidth.xsmall,
            Cell: data => {
                const rowData = [];

                // 削除キャンセル
                if (data.original.status === "WAITING" && this.props.currentPermission.delete) {
                    rowData.push(
                        <SetButtonWithSpeechBubble
                            key={"control_modal_c" + data.index}
                            bsSize="xsmall"
                            onClick={this.modalShow("callHistoryDeleteCancel", data.original)}
                            className="control-button"
                            DisplayIcon="minus"
                            speechBubble={langText.Body.DeleteCancel}
                        />
                    );
                }

                // 詳細データ閲覧
                if (data.original.status !== "WAITING") {
                    rowData.push(
                        <SetButtonWithSpeechBubble
                            key={"control_modal_d" + data.index}
                            bsSize="xsmall"
                            onClick={this.modalShow("callHistoryDeleteDetail", data.original)}
                            className="control-button"
                            DisplayIcon="list"
                            speechBubble={langText.Body.DetailDataOpen}
                        />
                    );
                }

                return (
                    <Row className="text-center" key={"row_modal" + data.index}>
                        {rowData}
                    </Row>
                );
            }
        });

        return columns;
    }

    onSearch = () => {
        let filter = [];

        this.state.filtered.forEach(row => {
            filter.push(row);
        });

        this.setState({
            hidden_filtered: filter,
            applied_search_target: this.state.search_target
        }, () => {
            this.table.current.state.page = 0;
            this.getBoardData(this.table.current.state);
        });
    }

    getBoardData = async (state) => {
        const {
            page,
            pageSize,
            sorted
        } = state;
        // ページング・ソート・モーダル再表示でも検索ボタンで確定した条件のみを使用する
        const searchFiltered = this.state.hidden_filtered;

        this.setState({ loading: true });

        try {
            const result = await this.ascAxios("post", `${this.props.reactContainerPath}/deleteHistoryBoard`, {
                page,
                pageSize,
                sorted,
                filtered: searchFiltered,
                hidden_filtered: searchFiltered,
                search_target: this.state.applied_search_target
            });

            this.setState({
                data: result.data.rows,
                page: state.page,
                pageSize: state.pageSize,
                pages: Math.ceil(result.data.count / state.pageSize),
                count: result.data.count,
                loading: false
            });
        } catch (err) {
            this.setState({
                data: [],
                pages: null,
                count: null,
                loading: false
            });
            this.showErrorObjectMesssage(err, "GetDataError_Server");
        }
    }

    onChange = (event, param) => {
        let my_filtered = this.state.filtered,
            target_index = my_filtered.findIndex(row => row.id === param),
            value = "";
        
        if(event) {
            value = event.target ? event.target.value : event;
        }

        if (target_index !== -1) {
            my_filtered.splice(target_index, 1);
        }

        if (value && (!Array.isArray(value) || value.length)) {
            my_filtered.push({
                id: param,
                value
            });
        }

        if (param === "cm12_id") {
            // 会社を変更・クリアした場合は外線番号の検索条件も一緒にクリアする
            const display_number_index = my_filtered.findIndex(row => row.id === "display_number");

            if (display_number_index !== -1) {
                my_filtered.splice(display_number_index, 1);
            }

            this.setState({ display_number: [] });

            if (event && event.value) {
                // 外線番号リスト取得
                this.getAllExternal(event.value);
            } else {
                // 外線番号リスト初期化
                this.setState({ external_arr: [] });
            }
        }

        if (param === "display_number") {
            this.setState({ [param]: event });
        }

        if (param === "search_target") {
            this.setState({ search_target: value ? value.value : 'deleted' });
            return;
        }

        this.setState({
            filtered: my_filtered
        });
    }

    getFilterData = (param) => {
        let my_param_data = this.state.filtered.find(row => row.id === param);
        return my_param_data ? my_param_data.value : "";
    }

    getAllExternal = async (cm12_id) => {
        try {
            const result = await this.ascAxios('post', `${this.props.reactContainerPath}/getallExternal`, { cm12_id });
            this.setState({external_arr: result.data});
        } catch (err) {
            alert(this.getErrorString(err.response.data));
        }
    }

    getCallHistoryInfoItem = () => {
        let {
            state,
            langText,
            validationHandle,
            onRadioChange,
            formatDisplayConditions,
            onCheckBoxChange,
            propSetState
        } = this.props;
        let itemArr = [];

        switch (state.modalType) {
            case "download":
                let search_date  = null;
                let downloadFileTypeRadio = state.downloadFileType;
                let downloadFileTypeRadioNomp3 = state.downloadFileTypeNoMp3;

                if (state.param) {
                    search_date = moment(state.param.original.start_datetime).format("YYYY-MM-DD")
                }
                
                if (typeof state.downloadFileType !="undefined") {
                    if (search_date < "2020-06-11") {
                        itemArr.push(
                            <InlineForm
                                key = "file_type"
                                controlId = "file_type"
                                label = {langText.Body.Download}
                                validationState = {validationHandle("file_type")}>
                                {downloadFileTypeRadioNomp3.map((row, key) =>
                                    <div key={key}>
                                        <Col xs={10} className="inboundType-text">
                                        <Radio
                                            name     = "download_type_radio"
                                            key      = {key}
                                            onChange = {e => onRadioChange(e, "file_type")}
                                            checked  = {row.value === state.file_type}
                                            value    = {row.value}
                                        >
                                            {row.label}
                                        </Radio>
                                        </Col>
                                    </div>
                                )}
                            </InlineForm>
                        );
                    } else {
                        itemArr.push(
                            <InlineForm
                                key = "file_type"
                                controlId = "file_type"
                                label = {langText.Body.Download}
                                validationState = {validationHandle("file_type")}>
                                {downloadFileTypeRadio.map((row, key) =>
                                    <div key={key}>
                                        <Col xs={10} className="inboundType-text">
                                        <Radio
                                            name     = "download_type_radio"
                                            key      = {key}
                                            onChange = {e => onRadioChange(e, "file_type")}
                                            checked  = {row.value === state.file_type}
                                            value    = {row.value}
                                        >
                                            {row.label}
                                        </Radio>
                                        </Col>
                                    </div>
                                )}
                            </InlineForm>
                        );
                    }
                }
                // ファイル名に通話履歴IDを付与するチェックボックス
                itemArr.push(
                    <div key="add_call_history_id_checkbox" className="margin-top-05">
                        <Checkbox
                            checked={!!state.add_call_history_id}
                            onChange={e => propSetState({ add_call_history_id: e.target.checked })}
                        >
                            {langText.Body.AddCallHistoryIdToFileName}
                        </Checkbox>
                    </div>
                );
                break;
            case "callHistoryDelete":
                itemArr.push(
                    // メッセージ
                    <div className="message">
                        <p>{langText.Message.CallHistoryDeleteMessage[0]}</p>
                        <p>
                            {langText.Message.CallHistoryDeleteMessage[1]}
                            <span className="delete-count">{state.searchCount !== "timeout" ? state.searchCount.toLocaleString() + langText.Body.Count : langText.Message.TooManyResultsMessage}</span>
                        </p>
                        {typeof state.searchCount === "number" && state.searchCount > this.props.callHistoryDelCountLimit &&
                            <p className="text-danger">{this.sprintf(langText.Message.CountLimitExceeded, this.props.callHistoryDelCountLimit.toLocaleString())}</p>
                        }
                        <p>{langText.Message.CallHistoryDeleteMessage[2]}</p>
                    </div>
                );
                // 検索条件
                const label = formatDisplayConditions(state.filtered);
                itemArr.push(
                    label.split("\n").map((line, index) => {
                        return <p key={"line" + index}>{line}</p>
                    })
                );

                if (state.delete_setting_expand) {
                    // 削除種類
                    itemArr.push(
                        <>
                            <Checkbox
                                checked={state.call_history_delete_flag}
                                onChange={e => onCheckBoxChange(e, "call_history_delete_flag")}
                            >
                                <span>{langText.Body.CallHistoryDelete}</span>
                                {
                                    state.call_history_delete_flag &&
                                    <span className="waring-sentence">
                                        <FontAwesomeIcon
                                            className="margin-right-02"
                                            icon={solidfaIcon.faExclamationTriangle}
                                        />
                                        {langText.Message.Company_CallHistoryDelete}
                                    </span>
                                }
                            </Checkbox>
                            <Checkbox
                                checked={state.voice_log_delete_flag}
                                onChange={e => onCheckBoxChange(e, "voice_log_delete_flag")}
                            >
                                <span>
                                    {langText.Body.VoiceLogDelete}
                                </span>
                                {
                                    state.voice_log_delete_flag &&
                                    <span className="waring-sentence">
                                        <FontAwesomeIcon
                                            className="margin-right-02"
                                            icon={solidfaIcon.faExclamationTriangle}
                                        />
                                        {langText.Message.Company_VoiceLogDelete}
                                    </span>
                                }
                            </Checkbox>
                        </>
                    );
                };
                break;
            default:
                break;
        }
        
        return itemArr;
    }

    getModalInfo = () => {
        let {
            state,
            propSetState,
            langText,
            currentPermission,
            onPlayHandle,
            updateVoiceData,
            copyData,
            getCallRankList,
            updateCallResultRankData,
            screenName,
            tableHeight
        } = this.props;
        let info = null;

        switch (state.modalType) {
            case "download":
                info = (
                    <Panel bsStyle="info">
                        <Panel.Heading>
                            <Panel.Title>
                                {langText.Body.DownloadFlag}
                            </Panel.Title>
                        </Panel.Heading>
                        <Panel.Body>
                            {this.getCallHistoryInfoItem()}
                        </Panel.Body>
                    </Panel>
                );
                break;

            case "callRecordingPlay":
                info = (
                    <>
                        <Panel bsStyle="info">
                            <Panel.Heading>
                                <Panel.Title>
                                    {langText.Body.CallResultRank}
                                </Panel.Title>
                            </Panel.Heading>
                            <Panel.Body>
                                <ViewCallResultElement
                                    state={state}
                                    langText={langText}
                                    propSetState={propSetState}
                                    getCallRankList={getCallRankList}
                                    updateCallResultRankData={updateCallResultRankData}
                                    screenName={screenName}
                                    currentPermission={currentPermission}
                                />
                            </Panel.Body>
                        </Panel>
                        {
                            !state.isNotAnswered &&
                            <Panel bsStyle="info">
                                <Panel.Heading>
                                    <Panel.Title>
                                        {langText.Body.VoiceText}
                                        {state && state.selected && state.selected.text_data_json.length !==0 && 
                                        //音声テキストがあれば全体音声テキストコピーボタン・自動スクロールボタン表示
                                        <>
                                        <span className="pannel-btn-right">
                                            <SetButtonWithSpeechBubble
                                                className="control-button"
                                                bsSize="xsmall"
                                                onClick={e => {
                                                    let player = document.getElementById("audio-text-player");
                                                    let panel = document.getElementById("voice-text-panel");
 
                                                    // アクティブなメッセージボックスの色をリセット
                                                    const ELEMENT_CLASS_NAMES = ["current-message-box-right", "current-message-box-left"];
                                                    const messages = document.getElementById("voice-text-panel");
                                                    if (messages && messages.children) {
                                                        for (let i = 0; i < messages.children.length; i++) {
                                                            if (messages.children[i].firstElementChild) {
                                                                messages.children[i].firstElementChild.classList.remove(...ELEMENT_CLASS_NAMES);
                                                            }
                                                        }
                                                    }

                                                    // 現在の音声位置を設定する変数
                                                    let currentMessageIndex = 0;
                                                    let currentMessageData = null;

                                                    // 現在再生時間に該当するメッセージを検索
                                                    for (let i = 0; i < state.selected.text_data_json.length; i++) {
                                                        let currentTime = Math.round(player.currentTime);
                                                        let startTime = Math.round(state.selected.text_data_json[i].startTime);
                                                        let endTime = state.selected.text_data_json[i+1] ? 
                                                            Math.round(state.selected.text_data_json[i+1].startTime) : 
                                                            Math.round(state.selected.text_data_json[i].endTime);

                                                        if(currentTime >= startTime && currentTime <= endTime){
                                                            currentMessageIndex = i;
                                                            currentMessageData = state.selected.text_data_json[i];

                                                            // 自動スクロールOFFからONに切り替わる場合のみスクロール実行
                                                            if (player.readyState > 0 && !player.paused && !state.auto_scroll_flag) {
                                                                // 該当するメッセージボックスの位置にスクロール
                                                                let element = document.getElementById("message-box-"+i);
                                                                let element2 = document.getElementById("message-box-"+(i+1));
                                                                if (element) {
                                                                    let rect = element.getBoundingClientRect();
                                                                    let rect2 = element2 ? element2.getBoundingClientRect() : element.getBoundingClientRect();
                                                                    panel.scrollTo(0, (rect.bottom + rect2.bottom)/2 + panel.scrollTop - 440);
                                                                }
                                                            }
                                                            break;
                                                        }
                                                    }

                                                    propSetState({
                                                        auto_scroll_flag: !state.auto_scroll_flag,
                                                        message_box_data: currentMessageData || [],
                                                        message_box_index: currentMessageIndex,
                                                    });
                                                }}
                                                DisplayIcon="resize-vertical"
                                                speechBubble={langText.Body.AutoScroll}
                                            />
                                            <SetButtonWithSpeechBubble
                                                className="control-button"
                                                bsSize="xsmall"
                                                onClick={e => copyData("voice-all", state.selected.text_data_json)}
                                                disabled={state.voice_edit_flag.some(row => row)}
                                                DisplayIcon="copy"
                                                speechBubble={langText.Body.Copy}
                                            />
                                        </span>
                                        </>
                                        }
                                    </Panel.Title>
                                </Panel.Heading>
                                <ViewVoiceTextElement
                                    state={state}
                                    langText={langText}
                                    copyData={copyData}
                                    propSetState={propSetState}
                                    updateVoiceData={updateVoiceData}
                                    screenName={screenName}
                                    getKeywordData={function() {
                                        return "";
                                    }}
                                    currentPermission={currentPermission}
                                />
                                <Panel.Footer className="analysis-audio-control-footer">
                                    <ViewAudioControlElement
                                        state={state}
                                        langText={langText}
                                        copyData={copyData}
                                        propSetState={propSetState}
                                        onPlayHandle={onPlayHandle}
                                        getKeywordData={function() {
                                            return "";
                                        }}
                                        currentPermission={currentPermission}
                                        playbackSettings={this.props.playbackSettings}
                                    />
                                </Panel.Footer>
                            </Panel>
                        }
                    </>
                );
                break;
            case "callHistoryDelete":
                info = (
                    <>
                        <Panel bsStyle="info">
                            <Panel.Body>
                                {this.getCallHistoryInfoItem()}
                            </Panel.Body>
                        </Panel>
                        <Col sm={12} md={12} className="text-right">
                            <span className="waring-sentence waring-font">
                                <FontAwesomeIcon
                                    className="margin-right-02"
                                    icon={solidfaIcon.faExclamationTriangle}
                                />
                                {langText.Message.CallHistoryDeleteExecAlertMessage}
                            </span>
                        </Col>
                    </>
                );
                break;
            case "callHistoryDeleteHistory":
                info = (
                    <>
                        {
                            this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.oem) &&
                            <Row className="margin-bottom-05">
                                <Col sm={4} md={2} lg={1} className="padding-right-0">
                                    <div className="margin-top-05">{langText.Body.CompanyName}</div>
                                </Col>
                                <Col sm={12} md={6} lg={4}>
                                    <Select
                                        value={this.getFilterData("cm12_id")}
                                        onChange={
                                            e => this.onChange(e, "cm12_id")
                                        }
                                        options={state.companySelect}
                                        isClearable={true}
                                        placeholder={langText.SelectOption.Placeholder}
                                    />
                                </Col>
                            </Row>
                        }
                        <Row className="flex-style margin-bottom-05">
                            <Col sm={4} md={2} lg={1} className="padding-right-0">
                                <div className="margin-top-05">{langText.Body.ExternalNumber}</div>
                            </Col>
                            <Col sm={12} md={3} lg={4}>
                                <MultiSelect
                                    hasSelectAll={true}
                                    key="modal_display_number"
                                    value={this.state.display_number}
                                    onChange={
                                        e => this.onChange(e, "display_number")
                                    }
                                    options={this.state.external_arr}
                                    overrideStrings={{
                                        selectSomeItems: langText.SelectOption.Placeholder_defaultexternal,
                                        allItemsAreSelected: langText.SelectOption.Placeholder_defaultexternal,
                                        selectAll: langText.SelectOption.Placeholder_defaultexternal,
                                        selectAllFiltered: langText.SelectOption.Placeholder_searchAllResult,
                                        search: langText.Body.Search,
                                    }}
                                />
                            </Col>
                            <Col sm={4} md={3} lg={2} className="padding-right-0">
                                <div className="margin-top-05">
                                    <SetDataWithSpeechBubble
                                        custom="tooltip-wide"
                                        displayData={langText.Body.ExternalSearchCondition}
                                        speechBubbleData={
                                            <div>
                                                {langText.Body.ExternalSearchConditionTooltip.split('\n').map((line, i) => (
                                                    <span key={i}>{line}<br /></span>
                                                ))}
                                            </div>
                                        }
                                        infoIconDisplayFlag={true}
                                        infoIconType={solidfaIcon.faInfoCircle}
                                        infoIconClassName="modal-info-icon"
                                        infoIconColor="silver"
                                        infoIconSize="lg"
                                    />
                                </div>
                            </Col>
                            <Col sm={12} md={3} lg={3}>
                                <Select
                                    value={(this.delete_search_target_list || []).find(o => o.value === this.state.search_target) || null}
                                    onChange={
                                        e => this.onChange(e, "search_target")
                                    }
                                    options={this.delete_search_target_list}
                                    isClearable={false}
                                    placeholder={langText.SelectOption.Placeholder}
                                />
                            </Col>
                        </Row>
                        <Row className="flex-style">
                            <Col sm={4} md={2} lg={1} className="padding-right-0">
                                <div className="margin-top-05">{langText.Body.ExecStatus}</div>
                            </Col>
                            <Col sm={12} md={3} lg={3}>
                                <Select
                                    value={this.getFilterData("exec_status")}
                                    onChange={
                                        e => this.onChange(e, "exec_status")
                                    }
                                    options={this.exec_status_list}
                                    isClearable={true}
                                    placeholder={langText.SelectOption.Placeholder}
                                />
                            </Col>
                            <Col sm={12} md={2} lg={2} className="text-right margin-left-auto margin-top-05">
                                <Button
                                    id="customer-insert"
                                    className="searchBtn"
                                    bsStyle='primary'
                                    bsSize='sm'
                                    onClick={this.onSearch}
                                    disabled = {this.state.loading}
                                >
                                    {langText.Body.Search}
                                </Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12} className="margin-top-2">
                                <CommonTable
                                    className="call-history-modal"
                                    talbeRef={this.table}
                                    style={{height: tableHeight - 210}}
                                    manual="manual"
                                    columns={this.state.columns}
                                    data={this.state.data}
                                    pages={this.state.pages}
                                    pageSize={this.state.pageSize}
                                    loading={this.state.loading}
                                    defaultSorted={[{id: "execution_start_datetime", desc: true}]}
                                    onFetchData={(state, instance) => {
                                        this.getBoardData(state);
                                    }}
                                    filtered={this.state.filtered}
                                    hidden_filtered={this.state.hidden_filtered}
                                    previousText={langText.Table.PreviousText}
                                    nextText={langText.Table.NextText}
                                    loadingText={langText.Table.LoadingText}
                                    noDataText={langText.Table.NoDataText}
                                    rowsText={langText.Table.RowsText}
                                />
                            </Col>
                        </Row>
                    </>
                );
            default:
                break;
        }

        return info;
    }

    createCountDisplayMessage = () => {
        let message  = this.props.langText.Body.SearchResult;

        if (typeof(this.props.state.searchCount) === "number") {
            message += this.props.langText.Body.About + this.props.state.searchCount.toLocaleString() + this.props.langText.Body.Count;
        } else {
            // タイムアウト(エラー)
            message += this.props.langText.Message.TooManyResultsMessage;
        }
        return message;
    }

    modalShow = (modalType, param) => event => {
        event.preventDefault();
        let setData = null;

        switch (modalType) {
            case "callHistoryDeleteCancel":
                setData = {
                    id: param && param.id ? param.id : null,
                    del_count: param && param.del_count !== null ? param.del_count : null,
                    condition: param && param.condition ? param.condition : {},
                    condition_display: param && param.condition_display ? param.condition_display : {},
                    delete_setting_expand: this.props.state.delete_setting_expand
                };
                this.props.initConfirmPopup();
                break;
            case "callHistoryDeleteDetail":
                setData = {
                    id: param && param.id ? param.id : null,
                    cm12_id: param && param.cm12_id ? param.cm12_id : null,
                    del_count: param && param.del_count ? param.del_count : 0,
                    condition: param && param.condition ? param.condition : {},
                    condition_display: param && param.condition_display ? param.condition_display : {},
                    call_history_delete_flag: param && param.condition && param.condition.call_history_delete_flag === "Y" ? true : false,
                    voice_log_delete_flag: param && param.condition && param.condition.voice_log_delete_flag === "Y" ? true : false,
                    delete_setting_expand: this.props.state.delete_setting_expand
                };
                break;

            default:
                break;
        }

        setData = {
            ...setData,
            modalType,
            show: true
        };

        this.setState(setData);
    }

    onClickHandle = async () => {
        let {
            id,
            modalType
        } = this.state;

        await this.props.onClick(this.state.modalType)(id);

        this.setState({
            show: false
        }, () => {
            if (modalType === "callHistoryDeleteCancel") {
                this.onSearch();
            }
        });
    }

    render() {
        return (
            <div className="CallHistoryModal">
                {
                    this.props.state.modalType === "callHistoryDownload" ?
                        <AscModal
                            state = {this.props.state}
                            propSetState = {this.props.propSetState}
                            langText = {this.props.langText}
                            validationHandle = {this.props.validationHandle}
                            onClick = {this.props.onClick}>
                            <Panel bsStyle="info">
                                <Panel.Body>
                                    <div className="message">
                                        <p>{this.createCountDisplayMessage()}</p>
                                        <p>{this.props.langText.Message.CallHistoryDownloadMessage[0]}</p>
                                        <p>{this.props.langText.Message.CallHistoryDownloadMessage[1]}</p>
                                        <p>{this.props.langText.Message.CallHistoryDownloadMessage[2]}</p>
                                        <p className="text-danger">{this.props.langText.Message.DownloadDeadline}</p>
                                    </div>
                                    <Col sm={12} md={12} className="padding-left-0">
                                        <Col sm={12} md={3} lg={2} className="padding-left-0 margin-top-05 width-auto">
                                            {this.props.langText.Body.FileName}
                                        </Col>
                                        <Col sm={12} md={9} lg={9} className="padding-left-0">
                                            <InlineForm
                                                key="fileName"
                                                controlId="fileName"
                                                type="text"
                                                value={this.props.state.fileName}
                                                onChange={e => this.props.onTextChange_Limit(e, "fileName", this.props.charaLimit.File_Name)}
                                                placeholder={this.props.state.fileName}
                                            />
                                            {this.props.hasInvalidFileNameCharacters(this.props.state.fileName) &&
                                                <div className="text-danger margin-top--05">
                                                    {this.props.langText.Message.InvalidFileNameCharacters}
                                                </div>
                                            }
                                            {typeof this.props.state.searchCount === "number" && this.props.state.searchCount > this.props.callHistoryDlCountLimit &&
                                                <div className="text-danger margin-top--05">
                                                    {this.sprintf(this.props.langText.Message.CountLimitExceeded, this.props.callHistoryDlCountLimit.toLocaleString())}
                                                </div>
                                            }
                                        </Col>
                                    </Col>
                                </Panel.Body>
                            </Panel>
                        </AscModal>
                    :
                        this.props.state.modalType === "callHistoryDelete" ?
                            <AscModal
                                state={this.props.state}
                                propSetState={this.props.propSetState}
                                langText={this.props.langText}
                                validationHandle={this.props.validationHandle}
                                customFunc={() => {
                                    this.props.initConfirmPopup();
                                    this.setState({
                                        show: true,
                                        modalType: "callHistoryDeleteExec"
                                    });
                                }}
                            >
                                {this.getModalInfo()}
                            </AscModal>
                        :
                            <AscModal
                                state={this.props.state}
                                propSetState={this.props.propSetState}
                                langText={this.props.langText}
                                validationHandle={this.props.validationHandle}
                                onClick={this.props.onClick}
                                {...(this.props.state.modalType === "callHistoryDeleteHistory" ? {
                                    customBtn1Func: () => {this.props.propSetState({ show: false })},
                                    customBtn1Msg: this.props.langText.Body.Close
                                } : {})}
                            >
                                {this.getModalInfo()}
                            </AscModal>
                }
                <CallHistoryDetailModal
                    state={this.state}
                    propState={this.props.state}
                    propSetState={this.propSetState}
                    langText={this.props.langText}
                    onClick={this.onClickHandle}
                    validationHandle={this.props.validationHandle}
                    onChange={this.props.onChange}
                    reactContainerPath={this.props.reactContainerPath}
                    formatDisplayConditions={this.props.formatDisplayConditions}
                    tableHeight={this.props.tableHeight}
                    ascAxios={this.ascAxios}
                    showErrorObjectMesssage={this.showErrorObjectMesssage}
                    onTextChange_Limit={this.props.onTextChange_Limit}
                    charaLimit = {this.props.charaLimit}
                />
            </div>
        );
    }
}
